import { render, staticRenderFns } from "./BreakoutSlide.vue?vue&type=template&id=8decd4b6&scoped=true&lang=pug"
import script from "./BreakoutSlide.vue?vue&type=script&lang=ts"
export * from "./BreakoutSlide.vue?vue&type=script&lang=ts"
import style0 from "./BreakoutSlide.vue?vue&type=style&index=0&id=8decd4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8decd4b6",
  null
  
)

export default component.exports